import { Container, Text, TextStyle } from 'pixi.js';

export class GameOverScreen {
    constructor(app) {
        this.app = app;
        this.container = new Container();
        this.container.visible = false;
        
        // Create game over text
        const style = new TextStyle({
            fontFamily: 'Press Start 2P',
            fontSize: 36,
            fill: '#ff0000',
            align: 'center',
            stroke: '#000000',
            strokeThickness: 4
        });
        
        this.gameOverText = new Text('GAME OVER', style);
        this.gameOverText.anchor.set(0.5);
        
        // Create restart text
        const restartStyle = new TextStyle({
            fontFamily: 'Press Start 2P',
            fontSize: 16,
            fill: '#ffffff',
            align: 'center',
            stroke: '#000000',
            strokeThickness: 2
        });
        
        this.restartText = new Text('Press SPACE to restart', restartStyle);
        this.restartText.anchor.set(0.5);
        this.restartText.y = 60;
        
        // Create menu text
        this.menuText = new Text('Press ESC to return to menu', restartStyle);
        this.menuText.anchor.set(0.5);
        this.menuText.y = 100;
        
        // Add texts to container
        this.container.addChild(this.gameOverText);
        this.container.addChild(this.restartText);
        this.container.addChild(this.menuText);
        
        // Add container to stage
        this.app.stage.addChild(this.container);
        
        // Add resize listener
        this.resizeHandler = () => this.resize();
        window.addEventListener('resize', this.resizeHandler);
        
        // Initial position
        this.container.x = this.app.screen.width / 2;
        this.container.y = this.app.screen.height / 2;
    }
    
    resize() {
        if (this.container && this.app) {
            this.container.x = this.app.screen.width / 2;
            this.container.y = this.app.screen.height / 2;
        }
    }
    
    show() {
        this.container.visible = true;
        this.resize(); // Ensure correct position when showing
    }
    
    hide() {
        this.container.visible = false;
    }
    
    destroy() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this.container && this.container.parent) {
            this.container.parent.removeChild(this.container);
        }
        this.container.destroy({ children: true });
    }
} 